import { Badge } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import useShop from "../../../../../../hooks/useShop";
import useUser from "../../../../../../hooks/useUsers";
import { getDecodeToken } from "../../../../../../shared/utils/Token";
import { theme } from "../../../../../../theme";
import color from "../../../../../../theme/color";
import { ArrowSmallLeft, Dot } from "../../../../Icon";
import { IconForm } from "../../../../Icon/index.styled";
import { LinkType, MainType } from "../../../constants";

interface Props {
  mainLink: MainType;
  setIdx: () => void;

  setClose: () => void;
  subLink: LinkType[];
  open: boolean;
}
const Box: React.FC<Props> = ({
  mainLink,
  subLink,
  setIdx,
  open,
  setClose,
}) => {
  const { pathname } = useLocation();

  const splittedPathName = pathname.split("/");
  const [isOpen, setOpen] = useState(open);
  const { getAdminInfo, getUserID } = useUser();
  const { shop } = useShop();

  useEffect(() => {
    setOpen(open);
  }, [open]);

  const isMaster = useMemo(() => {
    const info = getDecodeToken();
    return info?.isMaster && +shop === getUserID();
  }, [shop]);

  /**
   * 출장매장 여부
   * @notice 임시
   */
  const isOnsite = useMemo(() => {
    return getAdminInfo()?.repairShopType === "출장교체";
  }, []);

  const subMenus = useMemo(() => {
    let menus = [...subLink];
    if (mainLink.name === "고객센터") {
      menus = subLink.filter((sub) => sub.path !== "/inquiry");
      const inquiry = subLink.find(
        (sub) => sub.path === "/inquiry"
      ) as LinkType;
      if (!isMaster) {
        menus = menus.concat(inquiry);
      }
    }

    /**
     * 출장교체 예약현황만 남기기
     */
    if (isOnsite && mainLink.name === "예약관리") {
      menus = subLink.filter((sub) => sub.name !== "예약설정");
    }
    return menus;
  }, [isOnsite, shop, mainLink]);

  return (
    <div>
      <MainBox
        open={isOpen}
        onClick={() => {
          if (isOpen === true) setClose();
          else setIdx();
        }}
      >
        <StyledTitle>
          <StyledIcon> {mainLink.icon}</StyledIcon>
          {mainLink.name}
        </StyledTitle>
        <IconForm
          component={ArrowSmallLeft}
          rotate={isOpen ? 90 : 270}
          color={color.gray6}
          style={{ fontSize: 10, color: color.gray8 }}
        />
      </MainBox>
      <>
        {subMenus.map(
          (data, index) =>
            data.name &&
            (data.path === "/inquiry" ? (
              // ** 1:1문의 채널 링크 추가 */
              <a
                href="https://tirepick.channel.io"
                target="_blank"
                rel="noopener noreferrer"
                key={index}
              >
                <SubBox open={isOpen} isNow={false}>
                  {data.name}
                </SubBox>
              </a>
            ) : (
              <Link to={data.path} key={index}>
                <SubBox
                  open={isOpen}
                  isNow={
                    pathname === "/"
                      ? data.path === "/"
                      : data.path.includes(splittedPathName[1])
                  }
                >
                  {data.badge ||
                  (data.name === "예약설정" &&
                    getAdminInfo()?.repairShopStatusType === "제휴 승인") ? (
                    <Badge
                      count={<Dot fill="red" />}
                      offset={[8, 0]}
                      style={{ stroke: "transparent" }}
                    >
                      <DotContent
                        isNow={
                          pathname === "/"
                            ? data.path === "/"
                            : data.path.includes(splittedPathName[1])
                        }
                      >
                        {data.name}
                      </DotContent>
                    </Badge>
                  ) : (
                    data.name
                  )}
                </SubBox>
              </Link>
            ))
        )}
      </>
    </div>
  );
};

export default Box;

export const SubBox = styled.div<{ isNow: boolean; open?: boolean }>`
  display: flex;
  align-items: center;
  padding-left: 50px;
  height: 40px;
  box-sizing: border-box;
  cursor: pointer;
  transform: ${({ open }) => (open ? "translateY(0px)" : "translateY(-56px)")};
  position: relative;
  z-index: 70;
  margin: 0px;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* 인터넷익스플로러 */
  user-select: none;
  opacity: ${({ open }) => (open ? 1 : 0)};
  height: ${({ open }) => (open ? "48px" : "0px")};
  transition: all 0.3s;
  background-color: ${({ isNow, theme }) =>
    isNow ? theme.color.gray11 : theme.color.gray12};
  color: ${({ theme }) => theme.color.gray2};
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
`;
export const MainBox = styled.div<{ open: boolean }>`
  height: 56px;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* 인터넷익스플로러 */
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 80;
  padding: 0px 16px;
  cursor: pointer;

  fill: ${({ theme }) => theme.color.gray2};
  background-color: ${({ theme }) => theme.color.gray12};
  color: ${({ theme }) => theme.color.gray2};
  ${theme.typo.heading.b14};
  box-sizing: border-box;
`;
export const StyledTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 15px;
  line-height: 20px;
  font-weight: 700; // 상위메뉴만
`;
export const StyledIcon = styled.span`
  margin-right: 16px;
  height: 24px;
`;

export const DotContent = styled.span<{ isNow: boolean }>`
  &:hover {
    stroke: none;
  }
`;
